var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataPath)?_c('icon',_vm._b({class:_vm.css},'icon',_vm.attributes,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }